<template>
  <v-menu
    v-model="menuOpen"
    offset-y
    :left="!volumeOnRight"
    :right="volumeOnRight"
    content-class="audioController-menu"
    :close-on-content-click="false"
    :attach="isAttach"
  >
    <template v-slot:activator="{ on, attrs }">
      <slot
        name="activator"
        :volume="sliderValue"
        :attrs="attrs"
        :on="on"
        :menuOpen="menuOpen"
      />
    </template>
    <section class="audioController-contain">
      <section class="audioController-left" @click="handleSpeaker">
        <speaker-on-svg v-if="sliderValue !== 0" class="icon" />
        <speaker-off-svg v-else class="icon" />
      </section>
      <section class="audioController-right">
        <article v-if="false" class="audioController-progress">
          <span v-for="index in 16" :key="index"></span>
        </article>
        <article class="audioController-slider">
          <vue-slider
            v-model="sliderValue"
            :tooltip="'none'"
            :min="min"
            :max="max"
            :duration="0"
            width="186"
            @change="handleVolume"
          />
        </article>
      </section>
    </section>
  </v-menu>
</template>

<script>
import SpeakerOffSvg from './icons/SpeakerOffSVG.vue';
import SpeakerOnSvg from './icons/SpeakerOnSVG.vue';

export default {
  components: {
    SpeakerOffSvg,
    SpeakerOnSvg,
  },
  props: {
    value: { type: Number, default: 0 },
    min: { type: Number, default: 0 },
    max: { type: Number, default: 10 },
    speakerOn: { type: Boolean, default: false },
    volume: { type: Number, default: 0 },
    volumeOnRight: { type: Boolean, default: false },
    isAttach: { type: Boolean, default: false },
  },
  data() {
    return { sliderValue: 0, oldValue: 0, menuOpen: false };
  },
  watch: {
    value(val) {
      this.sliderValue = val;
    },
  },
  created() {
    if (this.speakerOn) {
      this.sliderValue = this.value;
      this.oldValue = this.value;
    } else {
      this.sliderValue = this.volume * 10;
    }
  },
  methods: {
    handleSpeaker() {
      this.toggleMute(this.sliderValue);
    },
    toggleMute(value) {
      if (value > 0) {
        this.sliderValue = 0;
      } else {
        this.sliderValue = this.oldValue || 1;
      }

      this.$emit('input', this.sliderValue);
      this.$emit('change', this.sliderValue);
      this.$emit('onSpeakerOn', this.sliderValue !== 0);
    },
    handleVolume(level) {
      this.oldValue = level;
      this.$emit('input', level);
      this.$emit('change', level);
      this.$emit('onSpeakerOn', level !== 0);
    },
  },
};
</script>

<style lang="scss" scoped>
.audioController {
  &-contain {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 375px;
    padding: 0 30px 10px 30px;
  }
  & .vue-slider {
    display: inline-block;
    margin: 15px 0;
    height: 100% !important;
    .vue-slider-process {
      background-color: transparent !important;
    }
  }
  &-menu {
    border-radius: 10px;
    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.16);
    background-color: #fff;
  }
  &-left {
    display: flex;
    align-items: center;
    padding-top: 15px;
    cursor: pointer;
    &:hover {
      opacity: 0.7;
    }
    svg {
      margin-right: 10px;
    }
    &::v-deep .v-input input {
      max-height: 20px;
    }
  }
  &-right {
    width: 243px;
    margin-left: 15px;
    padding-top: 10px;
  }
  &-progress {
    span {
      width: 6px;
      height: 6px;
      margin-right: 6px;
      border-radius: 2px;
      background-color: #f3f3f3;
      display: inline-block;
      &:last-child {
        margin-right: 0;
      }
    }
  }
}
</style>
